/**
 * @generated SignedSource<<61a2e0689052404e0a8be5dba62d0994>>
 * @relayHash acf23754c53b025f0d706b73195aa7ec
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID acf23754c53b025f0d706b73195aa7ec

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type MedicalReportAttachmentsChangedReason = "UPLOAD_SESSION_REVERTED" | "UPLOAD_STATUS_CHANGED";
export type deMedicalReportSubscription$variables = {
  patientId: string;
};
export type deMedicalReportSubscription$data = {
  readonly medicalReportAttachmentsChanged: {
    readonly attachments: ReadonlyArray<{
      readonly attachmentType: DocumentType;
      readonly fileName: string;
      readonly id: string;
      readonly progressNoteId: string;
      readonly updatedAt: string | null;
      readonly uploadStatus: FileUploadStatus | null;
      readonly url: string;
    }>;
    readonly reason: MedicalReportAttachmentsChangedReason;
  };
};
export type deMedicalReportSubscription = {
  response: deMedicalReportSubscription$data;
  variables: deMedicalReportSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": "medicalReportAttachmentsChanged",
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "MedicalReportAttachmentsChange",
    "kind": "LinkedField",
    "name": "de_medicalReportAttachmentsChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicalReportAttachment",
        "kind": "LinkedField",
        "name": "attachments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attachmentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deMedicalReportSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deMedicalReportSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "acf23754c53b025f0d706b73195aa7ec",
    "metadata": {},
    "name": "deMedicalReportSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "380e8c9c924538fd04f9ac759b295ade";

export default node;
